module.exports = __webpack_public_path__ + "static/media/messages-people-person-bubble-oval.64a5f684.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/messages-people-person-bubble-oval.svg
// module id = 890
// module chunks = 0